
// Minimal interactive helpers
document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-qty]");
  if (!btn) return;

  const input = document.querySelector(btn.getAttribute("data-target") || "#TWQty");
  if (!input) return;

  const delta = btn.getAttribute("data-qty") === "+1" ? 1 : -1;
  const next = Math.max(1, (parseInt(input.value || "1", 10) + delta));
  input.value = String(next);
});


// Simple modal helpers (Volume Pricing)
(function () {
  function getModal() {
    return document.getElementById("TWVolumeModal");
  }

  function openModal() {
    const m = getModal();
    if (!m) return;
    m.classList.remove("hidden");
    // Prevent background scroll while open
    document.documentElement.classList.add("overflow-hidden");
  }

  function closeModal() {
    const m = getModal();
    if (!m) return;
    m.classList.add("hidden");
    document.documentElement.classList.remove("overflow-hidden");
  }

  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-volume-open]")) {
      e.preventDefault();
      openModal();
      return;
    }
    if (e.target.closest("[data-volume-close]")) {
      e.preventDefault();
      closeModal();
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeModal();
  });
})();


// Currency toggle (CAD <-> USD) using Shopify localization form
(function () {
  const form = document.getElementById("CurrencyToggleForm");
  const toggle = document.getElementById("CurrencyToggle");
  if (!form || !toggle) return;

  const hidden = form.querySelector("[data-currency-code]");
  const knob = form.querySelector("[data-currency-knob]");

  // Determine current active currency as reliably as possible
  function getActiveCurrency() {
    // Shopify sometimes exposes the active currency here
    const shopifyActive = window.Shopify && (window.Shopify.currency && (window.Shopify.currency.active || window.Shopify.currency.iso_code));
    if (shopifyActive) return String(shopifyActive).toUpperCase();
    // Fall back to the hidden input rendered by Liquid
    if (hidden && hidden.value) return String(hidden.value).toUpperCase();
    // Last resort
    return "CAD";
  }

  function syncUI() {
    if (!knob) return;
    knob.classList.toggle("translate-x-5", toggle.checked);
    knob.classList.toggle("translate-x-0", !toggle.checked);
  }

  // Ensure base class exists so toggling works even if Liquid rendered without it
  if (knob && !knob.classList.contains("translate-x-0") && !knob.classList.contains("translate-x-5")) {
    knob.classList.add("translate-x-0");
  }
  // Ensure the toggle reflects the *actual* active currency on load
  const active = getActiveCurrency();
  toggle.checked = active === "USD";
  if (hidden) hidden.value = toggle.checked ? "USD" : "CAD";
  syncUI();

  toggle.addEventListener("change", () => {
    if (hidden) hidden.value = toggle.checked ? "USD" : "CAD";
    syncUI();
    // Submit to /localization (Shopify handles currency change when enabled in Markets)
    try {
      form.submit();
    } catch (e) {
      // no-op
    }
  });
})();



// Product media: hover zoom (50%) with cursor-based pan + thumbnail swapping + blue glow on selected thumb
(function () {
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  const wrap = qs("[data-tw-zoom]");
  const img = qs("#TWMainImage");
  const thumbs = qsa("[data-tw-thumb]");

  if (!wrap || !img) return;

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function setOriginFromEvent(ev) {
    const r = wrap.getBoundingClientRect();
    const x = ((ev.clientX - r.left) / r.width) * 100;
    const y = ((ev.clientY - r.top) / r.height) * 100;
    img.style.transformOrigin = `${clamp(x, 0, 100)}% ${clamp(y, 0, 100)}%`;
  }

  wrap.addEventListener("mouseenter", (ev) => {
    wrap.classList.add("is-zoomed");
    setOriginFromEvent(ev);
  });

  wrap.addEventListener("mousemove", (ev) => {
    if (!wrap.classList.contains("is-zoomed")) return;
    setOriginFromEvent(ev);
  });

  wrap.addEventListener("mouseleave", () => {
    wrap.classList.remove("is-zoomed");
    img.style.transformOrigin = "50% 50%";
  });

  function setMain(previewSrc, fullSrc, alt) {
    if (previewSrc) img.src = previewSrc;
    if (fullSrc) img.dataset.fullSrc = fullSrc;
    if (typeof alt === "string") img.alt = alt;
  }

  function setActiveThumb(el) {
    thumbs.forEach(t => t.classList.remove("is-active"));
    if (el) el.classList.add("is-active");
  }

  document.addEventListener("click", (e) => {
    const thumb = e.target.closest("[data-tw-thumb]");
    if (!thumb) return;
    e.preventDefault();

    const previewSrc = thumb.getAttribute("data-preview-src");
    const fullSrc = thumb.getAttribute("data-full-src");
    const alt = thumb.getAttribute("data-alt") || "";
    setMain(previewSrc, fullSrc, alt);
    setActiveThumb(thumb);
  });

  // On load: mark first thumb active if none flagged already
  const preActive = thumbs.find(t => t.classList.contains("is-active"));
  if (!preActive && thumbs.length) setActiveThumb(thumbs[0]);

  // Deterrent only: disable right-click on main image area
  wrap.addEventListener("contextmenu", (e) => e.preventDefault());
})();

// Variant selection + price updates + redirect to cart after add
(function () {
  let currentVariant = null;

  function moneyFromCents(cents, currency) {
    const v = (Number(cents || 0) / 100);
    try {
      return new Intl.NumberFormat(undefined, { style: "currency", currency: currency || "CAD" }).format(v);
    } catch {
      return v.toFixed(2);
    }
  }


  function normalizeTag(tag) {
    return String(tag || "").toLowerCase().replace(/[\s_-]+/g, "").trim();
  }

  function productHasTag(product, tagName) {
    const wanted = normalizeTag(tagName);
    const rawTags = product && product.tags;
    if (Array.isArray(rawTags)) {
      return rawTags.some(tag => normalizeTag(tag) === wanted);
    }
    if (typeof rawTags === "string") {
      return rawTags.split(",").some(tag => normalizeTag(tag) === wanted);
    }
    return false;
  }

  function makeAddonBox(config) {
    const wrap = document.createElement("div");
    wrap.className = "rounded-xl border border-blue-200 bg-blue-50 p-3";
    wrap.setAttribute("data-js-addon-wrap", config.key);
    wrap.innerHTML = `
      <input type="hidden" form="ProductFormTW" name="properties[${config.propertyName}]" value="No">
      <label class="flex items-start gap-3 text-sm text-slate-800">
        <input
          type="checkbox"
          form="ProductFormTW"
          name="properties[${config.propertyName}]"
          value="Yes"
          class="mt-1 h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500"
          data-addon-checkbox
          data-addon-label="${config.label}"
          data-addon-property-name="${config.propertyName}"
          data-addon-variant-id="${config.variantId}"
          data-addon-cents="${config.cents}"
        >
        <span>
          <span class="font-semibold">${config.title}</span>
          ${config.cents ? `<span class="font-semibold text-green-700">+ ${moneyFromCents(config.cents, "CAD")}</span>` : ""}
          <span class="block text-xs text-slate-600">${config.helpText}</span>
        </span>
      </label>
    `;
    return wrap;
  }

  function ensureTaggedAddonCheckboxes(product) {
    const form = document.getElementById("ProductFormTW");
    if (!form || !product) return;

    const configs = [
      {
        key: "hstand",
        tag: "hstand",
        existingSelector: "[data-hstand-checkbox]",
        title: "Add H-Stand",
        label: "H-Stand Add-on",
        propertyName: "H-Stand Add-on",
        variantId: "46196626915412",
        cents: 1500,
        helpText: "Adds an H-Stand to this item."
      },
      {
        key: "easel",
        tag: "easel",
        existingSelector: "[data-easel-checkbox]",
        title: "Add Adhesive Easel for Foamboard",
        label: "Adhesive Easel for Foamboard",
        propertyName: "Adhesive Easel for Foamboard",
        variantId: "46197607432276",
        cents: 1500,
        helpText: "Adds an adhesive easel back to this item."
      }
    ];

    const optionSelects = Array.from(form.querySelectorAll("[data-option-select]"));
    let insertAfter = optionSelects.length ? optionSelects[optionSelects.length - 1].closest("div") : form.querySelector('input[data-variant-id]');

    configs.forEach(config => {
      if (!productHasTag(product, config.tag)) return;
      if (document.querySelector(config.existingSelector) || document.querySelector(`[data-js-addon-wrap="${config.key}"]`)) return;
      const box = makeAddonBox(config);
      if (insertAfter && insertAfter.parentNode) {
        insertAfter.insertAdjacentElement("afterend", box);
        insertAfter = box;
      } else {
        form.prepend(box);
      }
    });
  }

  function getSelectedAddons() {
    return Array.from(document.querySelectorAll("[data-addon-checkbox]")).filter(cb => cb.checked).map(cb => ({
      label: cb.getAttribute("data-addon-label") || "Add-on",
      propertyName: cb.getAttribute("data-addon-property-name") || cb.getAttribute("data-addon-label") || "Add-on",
      variantId: Number(cb.getAttribute("data-addon-variant-id")),
      cents: Number(cb.getAttribute("data-addon-cents") || 0)
    })).filter(addon => addon.variantId);
  }

  function selectedAddonTotalCents() {
    return getSelectedAddons().reduce((sum, addon) => sum + Number(addon.cents || 0), 0);
  }

  function updateDisplayedPrices(product, variant) {
    if (!variant) return;
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : (product && product.currency) || "CAD";
    const displayPrice = Number(variant.price || 0) + selectedAddonTotalCents();

    document.querySelectorAll("[data-price]").forEach(el => {
      el.textContent = moneyFromCents(displayPrice, currency);
    });
  }

  function getProductData() {
    const el = document.getElementById("TWProductData");
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function collectSelectedOptions() {
    return Array.from(document.querySelectorAll("[data-option-select]")).map(s => s.value);
  }

  function findMatchingVariant(product, selectedOptions) {
    if (!product || !product.variants) return null;
    return product.variants.find(v => Array.isArray(v.options) && v.options.join("||") === selectedOptions.join("||")) || null;
  }

  function updateUIForVariant(product, variant) {
    if (!variant) return;
    currentVariant = variant;
    const idInput = document.querySelector("input[data-variant-id]");
    if (idInput) idInput.value = String(variant.id);

    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : (product && product.currency) || "CAD";

    updateDisplayedPrices(product, variant);

    const compareWrap = document.querySelector("[data-compare-wrap]");
    const compareEl = document.querySelector("[data-compare]");
    if (compareWrap && compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareWrap.style.display = "";
        compareEl.textContent = moneyFromCents(variant.compare_at_price, currency);
      } else {
        compareWrap.style.display = "none";
      }
    }

    const atcBtns = document.querySelectorAll("[data-add-to-cart]");
    atcBtns.forEach(btn => {
      if (variant.available === false) {
        btn.setAttribute("disabled", "disabled");
        btn.classList.add("opacity-60", "cursor-not-allowed");
        btn.textContent = "Sold out";
      } else {
        btn.removeAttribute("disabled");
        btn.classList.remove("opacity-60", "cursor-not-allowed");
        if (!btn.dataset.originalText) btn.dataset.originalText = btn.textContent.trim() || "Add to cart";
        btn.textContent = btn.dataset.originalText;
      }
    });
  }

  function initVariantHandling() {
    const product = getProductData();
    if (!product) return;

    ensureTaggedAddonCheckboxes(product);

    function onOptionChange() {
      const selected = collectSelectedOptions();
      const v = findMatchingVariant(product, selected);
      updateUIForVariant(product, v);
    }

    document.querySelectorAll("[data-option-select]").forEach(sel => {
      sel.addEventListener("change", onOptionChange);
    });

    document.querySelectorAll("[data-addon-checkbox]").forEach(checkbox => {
      checkbox.addEventListener("change", () => {
        updateDisplayedPrices(product, currentVariant);
      });
    });

    onOptionChange();
  }

  function buildMainCartItem(form) {
    const formData = new FormData(form);
    const properties = {};

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.*)\]$/);
      if (match && value !== "") {
        properties[match[1]] = value;
      }
    }

    return {
      id: Number(formData.get("id")),
      quantity: Math.max(1, Number(formData.get("quantity") || 1)),
      properties
    };
  }

  async function addToCartAndGoToCart() {
    const form = document.getElementById("ProductFormTW");
    if (!form) return;

    const btns = document.querySelectorAll("[data-add-to-cart]");
    btns.forEach(b => b.setAttribute("disabled", "disabled"));

    try {
      const selectedAddons = getSelectedAddons();

      if (!selectedAddons.length) {
        const formData = new FormData(form);
        const res = await fetch("/cart/add.js", { method: "POST", body: formData, headers: { "Accept": "application/json" } });
        if (!res.ok) throw new Error("Add to cart failed");
      } else {
        const product = getProductData();
        const mainItem = buildMainCartItem(form);

        selectedAddons.forEach(addon => {
          mainItem.properties[addon.propertyName] = "Yes";
        });

        const addonItems = selectedAddons.map(addon => ({
          id: addon.variantId,
          quantity: mainItem.quantity,
          properties: {
            "_Add-on for": product && product.title ? product.title : "Product",
            "_Main variant ID": String(mainItem.id),
            "_Add-on type": addon.label
          }
        }));

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ items: [mainItem].concat(addonItems) })
        });
        if (!res.ok) throw new Error("Add to cart failed");
      }

      window.location.href = "/cart";
    } catch (e) {
      alert("The selected add-on could not be added. Please confirm the add-on product variant ID is correct and the product is active in Shopify.");
      btns.forEach(b => b.removeAttribute("disabled"));
    }
  }

  function initAddToCartButtons() {
    document.querySelectorAll("[data-add-to-cart]").forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        addToCartAndGoToCart();
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initVariantHandling();
    initAddToCartButtons();
  });
})();




// Sticky header behavior (shrink + shadow)
(function () {
  const header = document.querySelector("[data-sticky-header]");
  if (!header) return;

  let stuck = false;
  const threshold = 20;

  function onScroll() {
    const shouldStick = window.scrollY > threshold;
    if (shouldStick !== stuck) {
      stuck = shouldStick;
      header.classList.toggle("is-stuck", stuck);
    }
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
})();

